import { render } from "./ResetToInitialPasscode.vue?vue&type=template&id=fc5a26fa"
import script from "./ResetToInitialPasscode.vue?vue&type=script&lang=js"
export * from "./ResetToInitialPasscode.vue?vue&type=script&lang=js"

import "./ResetToInitialPasscode.vue?vue&type=style&index=0&id=fc5a26fa&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__